function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M240.74,328.64c-25.19,12.24-39.06,32.87-33.81,41.12s32.53,4.62,52.81-11.24c22.55-17.63,25.94-22.74,36.89-34.5,5.16-5.54,8.33-16.14-4.81-13.17A212.32,212.32,0,0,0,240.74,328.64Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M398.4,43.35A255.9,255.9,0,0,0,5,305.66,255.92,255.92,0,0,0,305.69,507q5.42-1.08,10.76-2.39a53.11,53.11,0,0,0,5.63-1.43,255.89,255.89,0,0,0,185-296.9A254.16,254.16,0,0,0,398.4,43.35ZM281.86,388.67a19.71,19.71,0,0,0-7.43,22.87c10.72,30,16,47.64,18.67,57.78C177.72,489.41,66.44,413.49,43.59,298,24.28,200.42,74.13,104.91,159.05,62.36c2.89,10.29,38.36,61.43,79.95,89.6,49,33.22,87.18,49.68,128.14,54,.36,0,.72.06,1.08.08,12.94.65,29.13,9.35,34.09,26.91C406.38,247.38,409.72,301.26,281.86,388.67Z"
});

var SvgOnNosSiva2 = function SvgOnNosSiva2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnNosSiva2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ON_nos_siva_2.9645758d.svg";
export { ForwardRef as ReactComponent };